module.exports = __webpack_public_path__ + "img/delta-hall-washington-dc.a9d05f75.jpg";